module.exports = __webpack_public_path__ + "static/media/DueFuelEngine.027bf34f.png";